import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Http, HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpErrorInterceptor } from './helpers/http-error';


///////  Plugins
import { DataTableModule } from "angular-6-datatable";
//https://www.npmjs.com/package/angular-6-datatable
//import { Select2Module } from 'ng2-select2';

import { Select2Module } from 'ng2-select2';
import { LaddaModule } from 'angular2-ladda';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TagInputModule } from 'ngx-chips';
import { MessagesModule } from 'primeng/messages';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';


//// Components

import { AppComponent } from './components/app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MovieComponent } from './components/movie/movie.component';
import { MovieTimingComponent } from './components/movietiming/movietiming.component';
import { LoginComponent } from './components/login/login.component';
import { WalletComponent } from './components/wallet/wallet.component';
import { RefferalComponent } from './components/refferal/refferal.component';
import { EventsComponent } from './components/events/events.component';
import { WithdrawalsComponent } from './components/withdrawals/withdrawals.component';



import { LoginLayoutComponent } from './components/layouts/login.layout';
import { HomeLayoutComponent } from './components/layouts/main.layout';

//////Services

import { GlobalService } from './services/global/global.service';

import { MovieInfoService } from './services/movie/movie.service';
import { MovieTimingService } from './services/movie/movieTiming.service';
import { LoginService } from './services/login/login.service';
import { WalletService } from './services/wallet/wallet.service';
import { RefferalService } from './services/refferal/refferal.service';
import { EventsService } from './services/events/events.service';



///// Helpers

import { AuthGuard } from './helpers/auth.guard'
import { JwtInterceptor } from './helpers/jwt.interceptor'

import { AppRoutingModule } from './components/routing,module';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    SidebarComponent,
    MovieComponent,
    MovieTimingComponent,
    LoginComponent,
    LoginLayoutComponent,
    HomeLayoutComponent,
    WalletComponent,
    RefferalComponent,
    EventsComponent,
    WithdrawalsComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    DataTableModule,
    Select2Module,
    AutoCompleteModule,
    TagInputModule,
    LaddaModule.forRoot({
      style: "contract",
      spinnerSize: 40,
      spinnerColor: "red",
      spinnerLines: 12
    }),
    MessagesModule,
    BrowserAnimationsModule,
    FileUploadModule,
    AppRoutingModule,
    // InputTextModule, DataTableModule, ButtonModule, DialogModule,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger' // set defaults here
    }),
    Ng4LoadingSpinnerModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    AuthGuard, GlobalService, MovieInfoService, MovieTimingService, LoginService, WalletService, RefferalService, EventsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts